import React, { useState, useEffect, Fragment } from "react";
import Header from "../../Base/Header";
import OppComponent from "../../Components/Opportunity/oppComponent";
import {
  getAllOpportunities,
  applyOpportunity,
} from "../../helper/opportunity";
import Loader from "react-js-loader";

import { isAuthenticated } from "../../helper/authApiCalls/auth";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getPlaylistsByRandomCategory } from "../../helper/Playlists/playlist";
import PlaylistSlider from "../../Components/PlaylistSlider/playlistSlider";
import OpportunityPop from "../../Components/Opportunity/opportunityPop";

const ShowOpportunity = () => {
  const [opportunities, setOpportunities] = useState([]);
  const [selectedOpportunity, setSelectedOpportunity] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [randPlaylist1, setRandPlaylist1] = useState([]);
  const [randPlaylist2, setRandPlaylist2] = useState([]);
  const [loading2, setLoading2] = useState(true);

  let [isOpen, setIsOpen] = useState(false);

  async function getOpportunities() {
    let limit = 4;
    let approved = true;
    const opportunities = await getAllOpportunities(
      currentPage,
      limit,
      approved
    );

    const totalPageCount = Math.ceil(opportunities.data.total / limit);

    if (opportunities.success === true) {
      setTotalPageCount(totalPageCount);
      setOpportunities(opportunities.data.opportunities);
    } else {
      console.log("error");
    }
  }

  async function getRandPlaylist() {
    const playlist = await getPlaylistsByRandomCategory();
    console.log(playlist, "playlist");
    if (playlist.success === true) {
      console.log(playlist.data, "playlist");
      setLoading2(false);

      var array1 = playlist?.data[0];
      var array2 = playlist?.data[1];
      if (array2) {
        array1 = array1.concat(array2 ? array2 : []);
      }

      setRandPlaylist1(array1);
    }
  }

  useEffect(() => {
    getRandPlaylist();
  }, []);

  useEffect(() => {
    getOpportunities();
  }, [currentPage]);

  function closeModal() {
    setIsOpen(false);
  }

  function openModal() {
    setIsOpen(true);
  }

  return (
    <div>
      <ToastContainer />

      <Header />
      <div className="py-3 md:px-10 px-4 w-full h-full">
        <div className="text-[25px] font-[600] py-6 px-4">Opportunities</div>
        <div className="grid xl:grid-cols-4 md:grid-cols-3  grid-cols-2 gap-12 ">
          {opportunities &&
            opportunities.map((opportunity, index) => {
              console.log(opportunity, "opp");
              return (
                <OppComponent
                  opportunity={opportunity}
                  index={index}
                  setSelectedOpportunity={setSelectedOpportunity}
                  openModal={openModal}
                />
              );
            })}
        </div>
        <div>
          <div className="flex justify-center pt-6">
            <nav aria-label="Page navigation example ">
              <ul className="list-style-none flex   rounded-lg">
                <li>
                  <div
                    className="relative block rounded cursor-pointer bg-transparent py-1.5 px-3 text-sm text-neutral-600 transition-all duration-300 text-black  "
                    href="/"
                    onClick={() => {
                      if (currentPage > 1) {
                        setCurrentPage(currentPage - 1);
                      }
                    }}
                  >
                    {" <"}
                  </div>
                </li>
                {totalPageCount > 0 &&
                  [...Array(totalPageCount)].map((e, i) => {
                    return (
                      <li>
                        <div
                          className={
                            "relative block rounded  py-1.5 px-3 text-sm text-blue-500 transition-all duration-300 cursor-pointer" +
                            (currentPage === i + 1 ? "bg-black" : "")
                          }
                          href="/"
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </div>
                      </li>
                    );
                  })}

                <li>
                  <div
                    className="relative block rounded  py-1.5 px-3 text-sm  transition-all duration-300  text-black cursor-pointer"
                    href="/"
                    onClick={() => {
                      if (currentPage < totalPageCount) {
                        setCurrentPage(currentPage + 1);
                      }
                    }}
                  >
                    {" >"}
                  </div>
                </li>
              </ul>
            </nav>
          </div>
        </div>
        <div className="w-full h-full">
          {loading2 && (
            <Loader
              type="bubble-top"
              bgColor={"#000000"}
              size={50}
              color={"#000000"}
              title={"Loading Playlist"}
            />
          )}
          {randPlaylist1.length > 0 && (
            <>
              <PlaylistSlider
                heading={"Some Currated Playlists for you"}
                playlist={randPlaylist1}
              />
            </>
          )}
        </div>
      </div>
      {selectedOpportunity && (
        <OpportunityPop
          selectedOpportunity={selectedOpportunity}
          closeModal={closeModal}
          isOpen={isOpen}
          toast={toast}
        />
      )}
    </div>
  );
};

export default ShowOpportunity;
